<template>
  <div class="body_index">
    <index-header page="home"></index-header>
    <div class="_wrapper">
      <div class="welcome_box">
        <div v-if="studentType === 1" style="color:#fff;padding-left: 0.6rem;position:relative;top:-24px;">
					<p>
					<span style="color:#ff0000;">若360浏览器，请使用极速模式或使用其它浏览器报名</span><br>
					此次报名仅做资料登记，报名先后不代表录取顺序，请错开高峰期报名</p>
					</div>
        <div class="welcome">
          <h3 v-if="studentType === 1">欢迎您访问在线报名系统</h3>
          <h3 v-if="studentType === 2">欢迎访问随迁子女网上信息采集系统</h3>
          <div style="height: 90px;">
            <h4 v-if="timeText">网上{{sysName}}时间为{{timeText}}，请在此时间段内进行网上{{sysName}}</h4>
          </div>
          <h5>{{infoText}}</h5>
          <p>
           <input type="checkbox" v-model="hasRead">
           已阅读并接受
           <a v-if="studentType === 2" href="javascript:void(0)" @click="lookSafe">《填报信息隐私保护协议》</a>
           <a v-if="studentType === 1" href="javascript:void(0)" @click="lookSafe">《幼儿园报名信息隐私保护协议》</a>
          </p>
          <h6>
            <a href="javascript:void(0)" class="sx-btn sx-btn-min sx-btn-blue _first" @click="onClickSignup">{{studentType === 2 ? '我要填报' : '马上报名'}}</a>
            <router-link class="sx-btn sx-btn-min sx-btn-blue-out" :to='{path: "/index/login", query: {signupNoticeId}}'>{{studentType === 2 ? '我要查询' : '报名查询'}}</router-link>
          </h6>
        </div>
      </div>
    </div>
    <div style="width:100%;text-align:center;margin-top:30px;">
      <template v-if="areaId=='510112'">
      Copyright {{new Date().getFullYear()}} <a href="http://www.lqjydsj.cn" style="color:#000;">www.lqjydsj.cn</a>  All Rights Reserved. 龙泉教育大数据 版权所有 蜀ICP备19007218号 | <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51011202000252" style="color:#000;">川公网安备51011202000252号</a> 
      </template>
      <template v-else>
      Copyright {{new Date().getFullYear()}} <a href="http://www.sxw.cn" style="color:#000;">www.sxw.cn</a>  All Rights Reserved. 生学教育 版权所有 蜀ICP备 16026065号 | <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002001905" style="color:#000;">川公网安备51019002001905号</a> 
      </template>
    </div>
    <div class="mask" v-if="dialogShow"></div>
    <div class="safe-dialog" v-if="dialogShow &&studentType === 2">
      <h2>用户协议</h2>
      欢迎使用成都市{{areaName}}流动人员随迁子女网上信息采集系统（以下称之为采集系统），请您仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不使用，您进入采集系统，则意味着您将自愿遵守以下规则，并完全同意成都市{{areaName}}教育局管理您所填报的信息。
      <h3>一、总则</h3>
      1. 本系统命名为“{{areaName}}流动人员随迁子女网上信息采集系统”，以下简称“采集系统”。
      <br>
      2. 本系协议最终解释权均属成都市{{areaName}}教育局所有。
      <h3>二、隐私保护</h3>
      1. 凡是进行填报的用户皆为采集系统的用户。
      <br>
      2. 采集的用户个人信息都受到隐私保护，不接受任何个人或单位的查询，司法、检察机关需要除外。
      <br>
      3. 用户应对所提供的材料真实性负责，在入学安排过程中，发现提供虚假信息、证件、证明和其他材料弄虚作假者，一经查实将依法追究责任并取消入学资格。
      <div style="text-align:center;">
        <div class="sure-btn" @click="sureClick">确定</div>
      </div>
    </div>

    <div class="safe-dialog" v-if="dialogShow &&studentType === 1">
      <h2>用户协议</h2>
      欢迎使用成都市{{areaName}}幼儿园报名系统（以下称之为报名系统），请您仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不使用，若您进入报名系统，则意味着您将自愿遵守以下规则，并完全同意成都市{{areaName}}教育局管理您所报名的信息。
      <h3>一、总则</h3>
      1. 本系统命名为“{{areaName}}幼儿园报名系统”，以下简称“报名系统”。
      <br>
      2. 本系协议最终解释权均属成都市{{areaName}}教育局所有。
      <h3>二、隐私保护</h3>
      1. 凡是进行填报的用户皆为报名系统的用户。
      <br>
      2. 报名填写的用户个人信息都受到隐私保护，不接受任何个人或单位的查询，司法、检察机关需要除外。
      <br>
      3. 用户应对所提供的材料真实性负责，在入学安排过程中，发现提供虚假信息、证件、证明和其他材料弄虚作假者，一经查实将依法追究责任并取消入学资格。
      <div style="text-align:center;">
        <div class="sure-btn" @click="sureClick">确定</div>
      </div>
    </div>
    <!--todo delete-->
    <router-link to="/index/test_page" style="position: fixed; left: 0; bottom: 0; width: 30px; height: 30px; "></router-link>
  </div>
</template>

<script>
  import IndexCommon from './mixins/index_common';
  import PageIndex from './mixins/page_index';
  import IndexHeader from './components/IndexHeader';

  export default {
    mixins: [IndexCommon, PageIndex],
    components: { IndexHeader },
    data() {
      return {
        hasRead: false,
        dialogShow: false
      };
    },
    created() {
      // this.$store.commit('setIsMobile', false);
      // 手机访问不允许进入PC端
      if (this.$store.state.isMobile) {
        this.$router.push('/mobile');
      }
    },
    methods: {
      lookSafe() {
        console.log('查看协议', this.hasRead);
        this.dialogShow = true;
      },
      sureClick() {
        this.dialogShow = false;
      }
    }
  };
</script>

<style lang="stylus" scoped>
  .body_index {
    width 100%
    height 100%
    min-width 1200px
    min-height 840px
    background #56b9cf url("../../assets/images/index_bg.jpg") no-repeat top center
  }
  .welcome_box {
    position relative
    width 952px
    height 607px
    margin 5% auto 0
    background url("../../assets/images/index_login_bg.png") no-repeat top center
    .welcome {
      width 460px
      height 500px
      position absolute
      top 60px
      right 80px
      h3 {
        color #175375
        font-size 28px
        padding 20px 0 10px
      }
      h4 {
        color #175375
        font-size 20px
        font-weight 100
        padding 0 0 20px
      }
      h5 {
        background rgba(247,247,247,1)
        padding 15px
        border-radius 6px
        color #FC7759
        font-size 14px
        font-weight 100
        min-height 120px
        max-height 160px
        overflow auto
      }
      h6 {
        padding-top 60px
        img {
          width 180px
        }
        ._first {
          margin-right 40px
        }
      }
    }
  }

  .mask{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:9999px;
    background:rgba(0,0,0,0.3);
  }
  .safe-dialog{
    position:fixed;
    background:#fff;
    padding:50px;
    border:1px solid #ccc;
    top:200px;
    left:50%;
    margin-left:-400px;
    width:800px;
    // height:600px;
    h2{
      text-align:center;
    }
    .sure-btn{
      display:inline-block;
      background:rgb(45,172,189);
      width:100px;
      line-height:44px;
      height:44px;
      text-align:center;
      border-radius:4px;
      cursor:default;
      margin-top:30px;
      color:#fff;
      &:hover{
        color:#eee;
      }
    }
  }
</style>
